import { DialogBox } from "@/components/DialogBox/DialogBox";
import { CookiePreferences } from "@/components/SettingsDialog/CookiePreferences";
import { LanguageSettings } from "@/components/SettingsDialog/LanguageSettings";
import { TabsHeader } from "@/components/Tabs/Tabs";
import { UserDetails } from "@/components/UserDetails/UserDetails";
import { Box, Theme } from "@mui/material";
import { Dispatch, FC, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

const SettingDialogContent = () => {
  const [tab, setTab] = useState<string>("profile");
  const { t } = useTranslation();
  const tabs = [
    {
      label: t("common:title.profile"),
      value: "profile"
    },
    {
      label: t("common:title.language"),
      value: "language"
    },
    {
      label: t("common:title.privacy"),
      value: "privacy"
    }
  ];

  const renderTabContent = () => {
    switch (tab) {
      case "language":
        return <LanguageSettings />;
      case "privacy":
        return <CookiePreferences />;
      default:
        return <UserDetails />;
    }
  };

  return (
    <Box
      component={"div"}
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start"
      }}
    >
      <Box
        sx={{
          position: "sticky",
          top: "-21px",
          marginTop: "-21px",
          backgroundColor: (theme: Theme) => theme.surface.normal,
          paddingTop: "16px",
          width: "100%",
          zIndex: "2"
        }}
      >
        <TabsHeader tab={tab} changeTab={(tab) => (tab ? setTab(tab) : setTab("profile"))} tabs={tabs} defaultTabValue={"profile"} />
      </Box>
      {renderTabContent()}
    </Box>
  );
};

interface SettingsDialogProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export const SettingsDialog: FC<SettingsDialogProps> = ({ open, setOpen }) => {
  const { t } = useTranslation();

  return (
    <DialogBox
      title={t("common:title.settings")}
      message={<SettingDialogContent />}
      onClose={() => {
        return;
      }}
      open={open}
      setOpen={setOpen}
      args={undefined}
      hideConfirm
      hideDecline
    />
  );
};
